// extracted by mini-css-extract-plugin
module.exports = {"container":"CatalogExplorerCategory_container__ZyldJ","catalogsGrid":"CatalogExplorerCategory_catalogsGrid__wCSGA"};